exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".card-wrap[data-v-c92596e4]{box-sizing:border-box;width:100%;height:200px;overflow:auto;padding:10px;margin:8px 0 4px}.card-wrap[data-v-c92596e4],.dialog-item[data-v-c92596e4]{border:1px solid #c0ccda;border-radius:4px;font-size:14px;line-height:1.5}.dialog-item[data-v-c92596e4]{display:inline-block;margin:0 4px 4px;padding:4px}.card-footer[data-v-c92596e4]{text-align:right;font-size:14px;line-height:1.5}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-rewriter.js?id=data-v-c92596e4&scoped=true!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/views/OperationManage/AdvertisingSpace/AdManagement/Components/EditCampusDialog.vue
// module id = 625
// module chunks = 0